export var SELECTOR_LABEL_CLASS_PREFIX = 'SelectorLabel';